document.addEventListener("DOMContentLoaded", function () {
  const dataElement = document.getElementById("cart-calendar-data");

  if (!dataElement) return;

  const config = JSON.parse(dataElement.textContent);
  const French = flatpickr.l10ns.fr;
  const isFrench = document.documentElement.lang === "fr";
  const elements = {
    checkoutButton: document.getElementById("checkout"),
    checkoutReadyDeliveryMessage: document.getElementById(
      "checkout-ready-message-delivery",
    ),
    checkoutReadyPickupMessage: document.getElementById(
      "checkout-ready-message-pickup",
    ),
    btnDelivery: document.getElementById("btn-delivery"),
    btnPickup: document.getElementById("btn-pickup"),
    fulfillmentType: document.getElementById("fulfillment-type"),
    deliveryRoute: document.getElementById("delivery-route-attr"),
    pickupLocationSection: document.getElementById("pickup-location-section"),
    pickupLocation: document.getElementById("pickup-location"),
    postalCodeSection: document.getElementById("postal-code-section"),
    postalCodeInput: document.getElementById("postal-code-input"),
    postalCodeHint: document.getElementById("postal-code-hint"),
    deliveryDateSection: document.getElementById("delivery-date-section"),
    deliveryDateInput: document.getElementById("delivery-date-input"),
    deliveryDateHint: document.getElementById("date-hint-delivery"),
    pickupDateSection: document.getElementById("pickup-date-section"),
    pickupDateInput: document.getElementById("pickup-date-input"),
    pickupDateHint: document.getElementById("date-hint-pickup"),
    pickupHours: document.getElementById("pickup-hours-display"),
    deliveryModeButtons: document.getElementById("delivery-mode-buttons"),
    btnPostalCode: document.getElementById("btn-postal-code"),
    btnDropoffPoint: document.getElementById("btn-dropoff-point"),
    dropoffSection: document.getElementById("dropoff-section"),
    dropoffPointSelect: document.getElementById("dropoff-point-select"),
    noDeliveryDatesMsg: document.getElementById("no-delivery-dates-message"),
    christmasNotice: document.getElementById("christmas-notice"),
    openingHours: document.getElementById("opening-hours-attribute"),
    noDropoffDatesMsg: document.getElementById("no-dropoff-dates-message"),
  };

  if (!elements.checkoutButton) return;

  let hasRestrictedItem = config.hasRestrictedItem;
  const christmasDate = config.christmasDate;
  const finalChristmasDate = config.finalChristmasDate;

  if (hasRestrictedItem) {
    elements.christmasNotice.style.display = "block";
  }

  const pickupLocations = config.pickupLocations || {};
  const deliveryRoutes = config.deliveryRoutes || {};
  // Build a flat list of all dropoff points across all routes
  // Map each point name back to its route for automatic matching
  const dropoffRouteMap = {};
  Object.entries(deliveryRoutes).forEach(([routeName, routeData]) => {
    (routeData.dropoffPoints || []).forEach((point) => {
      dropoffRouteMap[point] = routeName;
    });
  });

  // Populate the dropdown once (alphabetically)
  Object.keys(dropoffRouteMap)
    .sort((a, b) => a.localeCompare(b))
    .forEach((point) => {
      const tagValue = point.split(" - ")[0].trim();
      const opt = document.createElement("option");
      opt.value = tagValue;
      opt.textContent = point;
      opt.dataset.fullName = point;
      opt.dataset.tagValue = tagValue;
      elements.dropoffPointSelect.appendChild(opt);
    });

  // Single canonical definition of day names / numbers
  const DAY_NUMBER = {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6,
  };

  const DAYS = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
  ];

  function setCheckoutButtonState(isEnabled) {
    elements.checkoutButton.style.display = isEnabled ? "block" : "none";

    const isPickup = elements.fulfillmentType.value === "Pickup";

    elements.checkoutReadyDeliveryMessage.style.display =
      isEnabled && !isPickup ? "block" : "none";
    elements.checkoutReadyPickupMessage.style.display =
      isEnabled && isPickup ? "block" : "none";
  }

  function formatYmd(date) {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
  }

  function ymdToDmy(ymd) {
    if (!ymd) return ymd;

    const parts = String(ymd).split("-");

    if (parts.length !== 3) return ymd;

    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  }

  function getEarliestDate(dates) {
    if (!dates || dates.length === 0) return null;

    return [...new Set(dates)].sort()[0];
  }

  function getLatestDate(dates) {
    if (!dates || dates.length === 0) return null;

    return [...new Set(dates)].sort().at(-1);
  }

  function ymdToDate(ymd) {
    if (!ymd) return null;

    const parts = String(ymd).split("-").map(Number);
    const [year, month, day] =
      parts[0] > 31 ? parts : [parts[2], parts[1], parts[0]];

    if (!year || !month || !day) return null;

    return new Date(year, month - 1, day);
  }

  function getAllowedDays(location) {
    return DAYS.filter(
      (day) => location && location[day] && location[day] !== "",
    ).map((day) => DAY_NUMBER[day]);
  }

  function getBlockedDates(location) {
    const dates = [];
    const specialDates = (location.specialHours || []).map(
      (entry) => entry.date,
    );

    (location.blockedDates || []).forEach((entry) => {
      if (!entry.start) return;

      if (entry.start === entry.end || !entry.end) {
        if (!specialDates.includes(entry.start)) {
          dates.push(entry.start);
        }

        return;
      }

      let current = new Date(`${entry.start}T00:00:00`);
      const end = new Date(`${entry.end}T00:00:00`);

      while (current <= end) {
        const dateStr = formatYmd(current);

        if (!specialDates.includes(dateStr)) {
          dates.push(dateStr);
        }

        current.setDate(current.getDate() + 1);
      }
    });

    return dates;
  }

  function getSelectedPickupLocation() {
    if (!elements.pickupLocation.value) return null;

    const selectedOption =
      elements.pickupLocation.options[elements.pickupLocation.selectedIndex];

    if (!selectedOption) return null;

    return pickupLocations[selectedOption.dataset.handle] || null;
  }

  function updatePickupHours(selectedDates) {
    const hoursDisplay = elements.pickupHours;

    if (selectedDates.length === 0 || !elements.pickupLocation.value) {
      hoursDisplay.style.display = "none";
      return;
    }

    const date = selectedDates[0];

    const dayKey = DAYS[date.getDay()];
    const dateKey = formatYmd(date);
    const selectedLocation = getSelectedPickupLocation();

    if (!selectedLocation) {
      hoursDisplay.style.display = "none";
      return;
    }

    const hours = selectedLocation[dayKey];
    const specialHours = selectedLocation.specialHours || [];
    const specialEntry = specialHours.find((entry) => entry.date === dateKey);
    const openingHoursLabel =
      config.translations?.opening_hours || "Opening hours";

    if (specialEntry) {
      hoursDisplay.innerHTML = `<b>${openingHoursLabel}:</b> ${specialEntry.open} - ${specialEntry.close}`;
      hoursDisplay.style.display = "block";

      return;
    }

    if (hours) {
      const formatted = hours
        .split(",")
        .map((slot) => slot.replace("-", " – "))
        .join(" & ");

      hoursDisplay.innerHTML = `<b>${openingHoursLabel}:</b> ${formatted}`;
      elements.openingHours.value = formatted;
      hoursDisplay.style.display = "block";
    } else {
      hoursDisplay.style.display = "none";
      elements.openingHours.value = "";
    }
  }

  const tomorrow = new Date();

  tomorrow.setDate(tomorrow.getDate() + 1);

  const oneYearFromNow = new Date();

  oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);

  const calendarOptions = {
    locale: isFrench ? { ...French, firstDayOfWeek: 1 } : { firstDayOfWeek: 1 },
    minDate: hasRestrictedItem ? christmasDate : tomorrow,
    maxDate: hasRestrictedItem ? finalChristmasDate : oneYearFromNow,
    dateFormat: "d-m-Y",
    disableMobile: true,
  };

  const deliveryPicker = flatpickr(elements.deliveryDateInput, {
    ...calendarOptions,

    onChange: function (selectedDates, dateStr) {
      if (dateStr) {
        setCheckoutButtonState(true);
        elements.deliveryDateHint.style.display = "none";
      } else {
        setCheckoutButtonState(false);
      }
    },
  });

  const pickupPicker = flatpickr(elements.pickupDateInput, {
    ...calendarOptions,
    maxDate: hasRestrictedItem ? finalChristmasDate : oneYearFromNow,

    onChange: function (selectedDates, dateStr) {
      if (dateStr) {
        setCheckoutButtonState(true);
        elements.pickupDateHint.style.display = "none";
      } else {
        setCheckoutButtonState(false);
      }

      updatePickupHours(selectedDates);
    },
  });

  elements.deliveryDateSection.style.display = "none";
  elements.pickupDateSection.style.display = "none";
  elements.postalCodeSection.style.display = "none";
  elements.pickupLocationSection.style.display = "none";

  setCheckoutButtonState(false);

  elements.btnDelivery.addEventListener("click", function () {
    elements.fulfillmentType.value = "Local Delivery";
    elements.btnDelivery.style.fontWeight = "bold";
    elements.btnPickup.style.fontWeight = "normal";

    elements.pickupLocationSection.style.display = "none";
    elements.deliveryDateSection.style.display = "none";
    elements.postalCodeSection.style.display = "block";
    elements.pickupDateSection.style.display = "none";
    elements.deliveryModeButtons.style.display = "block";
    elements.postalCodeSection.style.display = "none";
    elements.dropoffSection.style.display = "none";
    // reset sub-UI state
    elements.dropoffSection.style.display = "none";
    elements.postalCodeSection.style.display = "none";
    elements.btnPostalCode.classList.remove("active");
    elements.btnDropoffPoint.classList.remove("active");
    elements.btnDelivery.classList.add("active");
    elements.btnPickup.classList.remove("active");

    // show sub-mode buttons
    elements.deliveryModeButtons.style.display = "flex";

    elements.postalCodeInput.value = "";
    elements.deliveryRoute.value = "";

    elements.postalCodeHint.style.display = "none";
    elements.noDeliveryDatesMsg.style.display = "none";
    elements.pickupLocation.value = "";
    elements.pickupDateInput.value = "";
    elements.openingHours.value = "";
    document.querySelector('[name="attributes[Dropoff Point]"]').value = "";
    document.querySelector('[name="attributes[Dropoff Point Name]"]').value ="";




    deliveryPicker.set(
      "maxDate",
      hasRestrictedItem ? finalChristmasDate : null,
    );
    deliveryPicker.clear();
    pickupPicker.clear();

    elements.pickupHours.style.display = "none";

    setCheckoutButtonState(false);
  });

  // Postal code mode
  elements.btnPostalCode.addEventListener("click", () => {
    elements.postalCodeSection.style.display = "block";
    elements.dropoffSection.style.display = "none";
    setNoDeliveryMsg(true);
    setNoDropoffMsg(true);
    elements.deliveryDateSection.style.display = "none";
    elements.btnPostalCode.classList.add("active");
    elements.btnDropoffPoint.classList.remove("active");
    document.querySelector('[name="attributes[Dropoff Point]"]').value = "";
    document.querySelector('[name="attributes[Dropoff Point Name]"]').value ="";
  });

  elements.btnPickup.addEventListener("click", function () {
    elements.fulfillmentType.value = "Pickup";

    elements.btnPickup.style.fontWeight = "bold";
    elements.btnDelivery.style.fontWeight = "normal";

    elements.pickupLocationSection.style.display = "flex";

    elements.pickupLocation.value = "";

    elements.pickupDateSection.style.display = "none";
    elements.deliveryDateSection.style.display = "none";
    elements.postalCodeSection.style.display = "none";
    elements.deliveryModeButtons.style.display = "none";
    elements.dropoffSection.style.display = "none";
    elements.postalCodeSection.style.display = "none";

    // reset active states on sub-buttons
    elements.btnPostalCode.classList.remove("active");
    elements.btnDropoffPoint.classList.remove("active");
    elements.btnPickup.classList.add("active");
    elements.btnDelivery.classList.remove("active");

    elements.postalCodeInput.value = "";
    elements.deliveryRoute.value = "";
    const selectedOption = elements.dropoffPointSelect.selectedOptions[0];
    document.querySelector('[name="attributes[Dropoff Point]"]').value = "";
    document.querySelector('[name="attributes[Dropoff Point Name]"]').value ="";
    elements.deliveryDateInput.value = "";
    pickupPicker.clear();
    deliveryPicker.clear();

    elements.pickupHours.style.display = "none";

    setCheckoutButtonState(false);
  });

  // Dropoff point mode
  elements.btnDropoffPoint.addEventListener("click", () => {
    elements.dropoffSection.style.display = "block";
    elements.postalCodeSection.style.display = "none";
    elements.dropoffPointSelect.selectedIndex = 0;
    setNoDeliveryMsg(true);
    setNoDropoffMsg(true);
    elements.deliveryDateSection.style.display = "none";
    elements.btnDropoffPoint.classList.add("active");
    elements.btnPostalCode.classList.remove("active");
  });

  // When a dropoff point is selected, auto-match the route
  elements.dropoffPointSelect.addEventListener("change", function () {
    const selectedPoint = this.value;

    const selectedOption = elements.dropoffPointSelect.selectedOptions[0];
    document.querySelector('[name="attributes[Dropoff Point]"]').value =
      selectedOption.dataset.tagValue;
    document.querySelector('[name="attributes[Dropoff Point Name]"]').value =
      selectedOption.dataset.fullName;

    const matchedRoute = dropoffRouteMap[selectedOption.dataset.fullName];

    setNoDeliveryMsg(true);

    if (!selectedPoint) {
      elements.deliveryDateSection.style.display = "none";
      elements.deliveryRoute.value = "";
      deliveryPicker.clear();
      setCheckoutButtonState(false);
      return;
    }

    // const matchedRoute = dropoffRouteMap[selectedPoint];

    if (!matchedRoute || !deliveryRoutes[matchedRoute]) {
      elements.deliveryDateSection.style.display = "none";
      elements.deliveryRoute.value = "";
      deliveryPicker.clear();
      setCheckoutButtonState(false);
      return;
    }

    const now = new Date();
    const route = deliveryRoutes[matchedRoute];

    elements.deliveryRoute.value = matchedRoute;

    const availableDates = (route.dates || []).filter((date) => {
      const cutoff = route.cutoffs[date];
      if (!cutoff) return true;
      return now <= new Date(cutoff);
    });

    const effectiveDates = hasRestrictedItem
      ? availableDates.filter((date) => date >= christmasDate)
      : availableDates;

    const formattedDates = [...new Set(effectiveDates)].map(ymdToDmy);

    if (formattedDates.length === 0) {
      setNoDropoffMsg(false);
      return;
    }
    setNoDeliveryMsg(true);
    setNoDropoffMsg(true);

    deliveryPicker.set(
      "enable",
      formattedDates.length > 0 ? formattedDates : ["01-01-9999"],
    );

    /*const earliestDate = getEarliestFormattedDate(formattedDates);
    deliveryPicker.set(
      "minDate",
      hasRestrictedItem ? christmasDate : earliestDate,
    );*/

    elements.deliveryDateSection.style.display = "flex";
    deliveryPicker.clear();
    const earliestDate = getEarliestDate(effectiveDates);
    const firstAvailableDate = hasRestrictedItem
      ? ymdToDmy(earliestDate > christmasDate ? earliestDate : christmasDate)
      : ymdToDmy(earliestDate);

    deliveryPicker.set("minDate", firstAvailableDate);
    deliveryPicker.set("maxDate", ymdToDmy(getLatestDate(effectiveDates)));
    deliveryPicker.redraw();

    elements.deliveryDateHint.style.display = "block";
    setCheckoutButtonState(false);
  });

  elements.checkoutButton.addEventListener("click", function (event) {
    const hasValidDate =
      elements.deliveryDateInput.value || elements.pickupDateInput.value;

    if (!hasValidDate) {
      event.preventDefault();

      if (elements.fulfillmentType.value === "Local Delivery") {
        elements.deliveryDateSection.style.display = "flex";
        elements.deliveryDateHint.style.display = "block";
      }

      if (elements.fulfillmentType.value === "Pickup") {
        elements.pickupDateSection.style.display = "flex";
        elements.pickupDateHint.style.display = "block";
      }

      setCheckoutButtonState(false);
    }
  });

  elements.pickupLocation.addEventListener("change", function () {
    if (this.value) {
      const selectedLocation = getSelectedPickupLocation();

      if (!selectedLocation) return;

      const allowedDays = getAllowedDays(selectedLocation);
      const specialHours = selectedLocation.specialHours || [];
      const specialDates = specialHours.map((entry) => entry.date);
      const blockedDates = getBlockedDates(selectedLocation);

      pickupPicker.set("disable", [
        function (date) {
          const dateStr = formatYmd(date);

          const hasSpecialHours = specialDates.includes(dateStr);

          if (hasSpecialHours) {
            return false;
          }

          const isBlocked = blockedDates.some((blocked) => {
            if (typeof blocked === "string") {
              return blocked === dateStr;
            }

            if (blocked.from && blocked.to) {
              return dateStr >= blocked.from && dateStr <= blocked.to;
            }

            return false;
          });

          if (isBlocked) {
            return true;
          }

          if (!allowedDays.includes(date.getDay())) {
            return true;
          }

          const day = date.getDay();
          const daysToLastTuesday = ((day + 5) % 7) + 1;
          const cutoff = new Date(date);
          cutoff.setDate(date.getDate() - daysToLastTuesday);
          cutoff.setHours(23, 59, 59, 0);
          return new Date() > cutoff;
        },
      ]);

      elements.pickupDateSection.style.display = "flex";

      pickupPicker.clear();
      pickupPicker.redraw();

      elements.pickupDateHint.style.display = "block";
      elements.pickupHours.style.display = "none";

      setCheckoutButtonState(false);
    } else {
      elements.pickupDateSection.style.display = "none";
      elements.pickupHours.style.display = "none";
      pickupPicker.clear();
      setCheckoutButtonState(false);
    }
  });

 elements.postalCodeInput.addEventListener("input", function () {
  this.value = this.value.replace(/\D/g, "").slice(0, 5);

  const code = this.value.trim();

  if (code.length === 5) {
    const matchedRoutes = Object.keys(deliveryRoutes).filter((routeName) => {
      return (deliveryRoutes[routeName].postalCodes || [])
        .map((c) => c.trim())
        .includes(code);
    });

    if (matchedRoutes.length > 0) {
      const now = new Date();

      // Build routes with their available dates
      const routesWithDates = matchedRoutes
        .map((routeName) => {
          const route = deliveryRoutes[routeName];
          const availableDates = (route.dates || []).filter((date) => {
            const cutoff = route.cutoffs[date];
            return !cutoff || now <= new Date(cutoff);
          });
          const nextDate = [...availableDates].sort()[0];
          return { routeName, availableDates, nextDate };
        })
        .filter((r) => r.availableDates.length > 0);

      if (routesWithDates.length > 0) {
        // Pick route with soonest next delivery date
        const best = routesWithDates.sort(
          (a, b) => new Date(a.nextDate) - new Date(b.nextDate)
        )[0];

        elements.deliveryRoute.value = best.routeName;

        const uniqueDates = [...new Set(best.availableDates)];

        const effectiveDates = hasRestrictedItem
          ? uniqueDates.filter((date) => date >= christmasDate)
          : uniqueDates;

        const formattedDates = effectiveDates.map(ymdToDmy);

        if (formattedDates.length === 0) {
          setNoDropoffMsg(true);
          setNoDeliveryMsg(false);
          return;
        }

        deliveryPicker.set(
          "enable",
          formattedDates.length > 0 ? formattedDates : ["01-01-9999"]
        );

        elements.deliveryDateSection.style.display = "flex";
        deliveryPicker.clear();

        const earliestDate = getEarliestDate(effectiveDates);
        const firstAvailableDate = hasRestrictedItem
          ? ymdToDmy(earliestDate > christmasDate ? earliestDate : christmasDate)
          : ymdToDmy(earliestDate);

        deliveryPicker.set("minDate", firstAvailableDate);
        deliveryPicker.set("maxDate", ymdToDmy(getLatestDate(effectiveDates)));
        deliveryPicker.redraw();

        elements.postalCodeHint.style.display = "none";
        elements.noDeliveryDatesMsg.style.display = "none";
        elements.deliveryDateHint.style.display = "block";
        setCheckoutButtonState(false);

      } else {
        // All matched routes have no available dates left
        elements.deliveryDateSection.style.display = "none";
        elements.postalCodeHint.style.display = "none";
        elements.noDeliveryDatesMsg.style.display = "block";
        elements.deliveryRoute.value = "";
        deliveryPicker.clear();
        setCheckoutButtonState(false);
      }

    } else {
      // No route matched this postal code
      elements.deliveryDateSection.style.display = "none";
      elements.postalCodeHint.style.display = "block";
      elements.noDeliveryDatesMsg.style.display = "none";
      elements.deliveryRoute.value = "";
      deliveryPicker.clear();
      setCheckoutButtonState(false);
    }

  } else {
    elements.deliveryDateSection.style.display = "none";
    elements.postalCodeHint.style.display = "none";
    elements.noDeliveryDatesMsg.style.display = "none";
    elements.deliveryRoute.value = "";
    deliveryPicker.clear();
    setCheckoutButtonState(false);
  }
});


  document.addEventListener("click", function (e) {
    const removeBtn = e.target.closest("cart-remove-button");
    if (!removeBtn) return;

    setTimeout(function () {
      checkChristmasItems();
    }, 500);
  });

  function checkChristmasItems() {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        const hasChristmas = cart.items.some(
          (item) =>
            item.variant_id &&
            window.christmasVariants &&
            Object.values(window.christmasVariants).some(
              (section) => section[String(item.variant_id)] === true,
            ),
        );

        if (hasChristmas) {
          setChristmasCartAttribute(true);
        } else {
          setChristmasCartAttribute(false);
          deliveryPicker.clear();
          pickupPicker.clear();
          resetChristmasState();
        }
      });
  }

  function setNoDeliveryMsg(hide = true) {
    if (elements.noDeliveryDatesMsg) {
      elements.noDeliveryDatesMsg.style.display = hide ? "none" : "block";
    }
    setCheckoutButtonState(false);
  }

  function setNoDropoffMsg(hide = true) {
    if (elements.noDropoffDatesMsg) {
      elements.noDropoffDatesMsg.style.display = hide ? "none" : "block";
    }
    setCheckoutButtonState(false);
  }

  function setChristmasCartAttribute(value) {
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: { has_christmas_item: value ? "true" : "" },
      }),
    });
  }

  function resetChristmasState() {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        const stillHasChristmas = cart.items.some(
          (item) =>
            window.christmasVariants &&
            Object.values(window.christmasVariants).some(
              (section) => section[String(item.variant_id)] === true,
            ),
        );

        if (stillHasChristmas) return; // another christmas item still in cart, do nothing

        const christmasEl = document.getElementById("christmas-notice");
        if (christmasEl) christmasEl.style.display = "none";
        window.hasChristmasItem = false;
        hasRestrictedItem = false;
        elements.christmasNotice.style.display = "none";
        elements.noDeliveryDatesMsg.style.display = "none";

        const resetTomorrow = new Date();
        resetTomorrow.setDate(resetTomorrow.getDate() + 1);

        deliveryPicker.set("minDate", resetTomorrow);
        deliveryPicker.set("maxDate", null);
        deliveryPicker.clear();
        deliveryPicker.jumpToDate(new Date());
        deliveryPicker.redraw();

        pickupPicker.set("minDate", resetTomorrow);
        pickupPicker.set("maxDate", oneYearFromNow);
        pickupPicker.clear();
        pickupPicker.jumpToDate(new Date());
        pickupPicker.redraw();
      });
  }
});
